import actions from './actions'
import mutations from './mutations'

const cashback = {
    namespaced: true,
    state: {
        systems: [],
        isLoaded: false,
        pagination: {
            length: null,
            page: 1,
            total: null
        },
        filters: {
            fromDate: new Date(+new Date() - 2419200000).toISOString().split('T')[0], // current date minus month
            toDate: null,
            enabled: null,
            wasStartedUp: null,
            finished: null,
            countClientsFrom: null,
            countClientsTo: null,
            totalOrderFrom: null,
            totalOrderTo: null,
            name: null,
            bonusSystem: 'cashbackPercent'
        }
    },
    mutations,
    actions
}

export default cashback
